import { render } from "./Timesheet.vue?vue&type=template&id=5abbcca2&scoped=true"
import script from "./Timesheet.vue?vue&type=script&lang=js"
export * from "./Timesheet.vue?vue&type=script&lang=js"

import "./timesheet.scss?vue&type=style&index=0&id=5abbcca2&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abbcca2"]])

export default __exports__